import { render, staticRenderFns } from "./ActivityInfo.vue?vue&type=template&id=d2d22e4e"
import script from "./ActivityInfo.vue?vue&type=script&lang=js"
export * from "./ActivityInfo.vue?vue&type=script&lang=js"
import style0 from "./ActivityInfo.vue?vue&type=style&index=0&id=d2d22e4e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports